export default __webpack_public_path__ + "static/media/logo.a535b073.png";